<app-card-table
    #documentCategoryTable
    [tableTitle]="'service.settings.documents.header'"
    [translatePrefix]="prefixCategory"
    [columns]="columnsCategory"
    [hideCheckboxes]="true"
    [additionalFilter]="additionalFilterCategory()"
    [gridData]="store.data.getCategories()"
    [refreshCallback]="store.api.getCategories"
    [refreshCallbackFragment]="categoryFrag"
    [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
    [showDetail]="store.isAllowed('service.update')()"
    [showDelete]="store.isAllowed('service.update')()"
    (deleteCallbackWithEvent)="deleteCategory($event)"
    (createCallback)="openCategoryDialog()"
    (detailCallback)="openCategoryDialog($event)"
></app-card-table>
